import { Button } from "@material-ui/core";
import AppBar from '@material-ui/core/AppBar';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Zoom from '@material-ui/core/Zoom';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MenuIcon from '@material-ui/icons/Menu';
import clsx from 'clsx';
import { graphql, navigate, useStaticQuery } from "gatsby";
import PropTypes, { string } from 'prop-types';
import React from "react";
import Link from '../components/Link';
import LoginRequiredAlert from "../components/LoginRequiredAlert";
import { isLoggedIn, logout } from "../services/auth";
import IconLogout from "@material-ui/icons/ExitToApp";
import IconLogin from "@material-ui/icons/Person";
import ScrollTop from "../components/scrolltop";
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    appTitle: {
        color: "white",
        flexGrow: 1,
    },
    appTitleLink: {
        textDecoration: `none`,
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        //marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    }
}));

const DefaultLayout:React.FC<{
    title:string, 
    fullwidth: boolean, 
    authorizationRequired: boolean, 
    window: any,
    data: {
        allAsciidoc: {
            edges: {
                node: {
                    id:string,
                    document: {title:string},
                    fields: {slug:string}
                }
            }
        }
    }}> = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    const data = useStaticQuery(graphql`
        query {
            allAsciidoc {
                edges {
                    node {
                        id
                        document {
                            title
                        }
                        fields {
                            slug
                        }
                    }
                }
            }
        }
    `)


    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const handleLogout = () => logout(() => navigate("/"))
    const handleLogin = () => navigate("/login")

    const edges = data.allAsciidoc.edges

    edges.sort((a, b) => {
        const slugA = a.node.fields.slug
        const slugB = b.node.fields.slug
        if (slugA < slugB) {
            return -1
        }
        if (slugA > slugB) {
            return 1
        }
        return 0
    })

    const children = (!props.authorizationRequired || isLoggedIn()) ? props.children : <LoginRequiredAlert />

    const pageTitle = props.title ? 'E-DIXIT - ' + props.title : 'E-DIXIT'

    return (
        <div className={classes.root}>
            <AppBar position="static"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}>
                <Toolbar>
                    {/* // Comme ce n'est pas super bien fini, je prefere l'enlever pour le moment 
                    <IconButton color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}>
                        <MenuIcon />
                    </IconButton>
                    */}
                    <Link className={classes.appTitleLink} to="/">
                        <Typography variant="h6" className={classes.appTitle}> {pageTitle}</Typography>
                    </Link>
                    {!isLoggedIn() && <Button color="inherit" onClick={handleLogin} startIcon={<IconLogin />}>Mon compte</Button>}
                    {isLoggedIn() && <Button color="inherit" onClick={handleLogout} endIcon={<IconLogout />}>Se déconnecter</Button>}
                </Toolbar>
            </AppBar>
            <div id="back-to-top-anchor" />
            <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {edges.map(({ node }) => (
                        <ListItem button key={node.id}>
                            <Link to={node.fields.slug}>{node.document.title}</Link>
                        </ListItem>
                    ))}
                </List>
            </Drawer>
            {props.fullwidth && <main className={clsx({ [classes.contentShift]: open, })}>{children}</main>}
            {!props.fullwidth &&
                <Container maxWidth="lg">
                    <main className={clsx(classes.content, { [classes.contentShift]: open, })} >
                        {children}
                    </main>
                </Container>
            }
            <ScrollTop {...props}>
                <Fab color="secondary" size="small" aria-label="scroll back to top">
                    <KeyboardArrowUpIcon />
                </Fab>
            </ScrollTop>
        </div>
    )
}
export default DefaultLayout
